{
  "list": {
    "title": "Institutions",
    "description": "Consultez et gérez les institutions clientes.",
    "search": "Rechercher par nom, ville ou email owner...",
    "filter": {
      "all": "Tous les statuts",
      "status": {
        "none": "Aucun abonnement",
        "trialing": "Essai",
        "active": "Actif",
        "paused": "En pause",
        "past_due": "Impayé",
        "canceled": "Annulé",
        "incomplete": "Incomplet",
        "incomplete_expired": "Expiré"
      }
    },
    "table": {
      "name": "Nom",
      "owner": "Owner",
      "city": "Ville",
      "status": "Statut",
      "seats": "Sièges",
      "trialEndAt": "Fin d'essai",
      "createdAt": "Créée le"
    },
    "empty": {
      "title": "Aucune institution trouvée",
      "description": "Aucune institution ne correspond à vos critères de recherche."
    },
    "pagination": {
      "previous": "Précédent",
      "next": "Suivant",
      "page": "Page {{current}} sur {{total}}",
      "showing": "Affichage de {{from}} à {{to}} sur {{total}} institutions"
    }
  },
  "detail": {
    "title": "Institution",
    "back": "Retour",
    "notFound": "Institution introuvable",
    "viewOwner": "Voir le compte owner"
  },
  "section": {
    "title": "Institution",
    "description": "Gérer l'institution de cet owner",
    "infos": "Informations",
    "subscription": "Abonnement",
    "members": "Membres",
    "displayName": "Nom",
    "address": "Adresse",
    "city": "Ville",
    "state": "Région",
    "zipCode": "Code postal",
    "country": "Pays",
    "companyRegistration": "SIRET",
    "subscriptionStatus": "Statut",
    "noSubscription": "Aucun abonnement",
    "seatCount": "Seats",
    "complimentarySeatCount": "Seats offerts",
    "billableSeatCount": "Seats facturables",
    "edit": "Modifier les infos",
    "offerSeat": "Offrir un siège gratuit",
    "addPractitioner": "Ajouter un praticien",
    "cancelSubscription": "Annuler l'abonnement",
    "reactivateSubscription": "Réactiver l'abonnement",
    "noMembers": "Aucun membre",
    "noOwnedInstitution": "Cet utilisateur n'a pas encore d'institution",
    "institutionNotFound": "Institution introuvable",
    "memberType": {
      "complimentary": "Offert",
      "paid": "Facturé"
    },
    "memberColumns": {
      "name": "Nom",
      "email": "Email",
      "type": "Type seat",
      "createdAt": "Ajouté le",
      "actions": "Actions"
    },
    "removeMember": "Retirer ce membre",
    "removeMemberDialog": {
      "title": "Retirer ce membre",
      "description": "Êtes-vous sûr de vouloir retirer {{name}} ({{email}}) de l'institution ? Cette action décrémentera le seat count.",
      "cancel": "Annuler",
      "confirm": "Retirer"
    },
    "editDialog": {
      "title": "Modifier l'institution",
      "description": "Mettre à jour les informations de l'institution.",
      "cancel": "Annuler",
      "save": "Sauvegarder"
    },
    "offerSeatDialog": {
      "title": "Offrir un siège gratuit",
      "description": "Créer un nouvel utilisateur dans l'institution sans facturer Stripe. Le siège sera marqué comme offert et ne sera jamais facturé.",
      "firstName": "Prénom",
      "lastName": "Nom",
      "email": "Email",
      "phone": "Téléphone",
      "password": "Mot de passe initial",
      "cancel": "Annuler",
      "confirm": "Offrir le siège"
    },
    "addMemberDialog": {
      "title": "Ajouter un praticien",
      "description": "Créer un nouvel utilisateur facturable dans l'institution.",
      "firstName": "Prénom",
      "lastName": "Nom",
      "email": "Email",
      "phone": "Téléphone",
      "password": "Mot de passe initial",
      "cancel": "Annuler",
      "confirm": "Ajouter",
      "disabledNoSubscription": "Aucun abonnement actif ou en essai pour cette institution.",
      "disabledTrialCap": "Limite de sièges de l'essai atteinte."
    },
    "cancelSubscriptionDialog": {
      "title": "Annuler l'abonnement",
      "description": "L'abonnement Stripe sera annulé en fin de période. L'institution gardera l'accès jusqu'à la prochaine échéance.",
      "cancel": "Annuler",
      "confirm": "Annuler l'abonnement"
    },
    "reactivateSubscriptionDialog": {
      "title": "Réactiver l'abonnement",
      "description": "L'abonnement Stripe sera réactivé immédiatement.",
      "cancel": "Annuler",
      "confirm": "Réactiver"
    },
    "trial": {
      "title": "Essai",
      "trialEndAt": "Fin d'essai",
      "seats": "Sièges",
      "paymentMethod": "Moyen de paiement",
      "cardOnFile": "Carte enregistrée",
      "noCard": "Aucune carte",
      "activate": "Activer l'essai",
      "reactivate": "Relancer l'essai",
      "edit": "Modifier l'essai",
      "end": "Terminer l'essai",
      "status": {
        "none": "Aucun abonnement",
        "trialing": "Essai",
        "active": "Actif",
        "paused": "En pause",
        "past_due": "Impayé",
        "canceled": "Annulé",
        "incomplete": "Incomplet",
        "incomplete_expired": "Expiré"
      }
    },
    "trialDialog": {
      "activateTitle": "Activer l'essai",
      "editTitle": "Modifier l'essai",
      "description": "Configurez la date de fin de l'essai gratuit et le nombre de sièges maximum.",
      "trialEndAt": "Date de fin d'essai",
      "maxSeats": "Sièges maximum",
      "maxSeatsPlaceholder": "Sans limite",
      "maxSeatsHint": "Laissez vide pour ne pas limiter le nombre de sièges pendant l'essai.",
      "cancel": "Annuler",
      "activateConfirm": "Activer l'essai",
      "editConfirm": "Enregistrer"
    },
    "endTrialDialog": {
      "title": "Terminer l'essai",
      "description": "Si l'institution a une carte enregistrée, elle sera facturée immédiatement. Sinon, l'abonnement sera mis en pause et l'accès bloqué jusqu'à l'ajout d'une carte.",
      "cancel": "Annuler",
      "confirm": "Terminer l'essai"
    }
  },
  "success": {
    "institutionUpdated": "Institution mise à jour avec succès",
    "trialActivated": "Essai activé avec succès",
    "trialUpdated": "Essai mis à jour avec succès",
    "trialEnded": "Essai terminé avec succès",
    "seatOffered": "Seat offert avec succès",
    "memberAdded": "Praticien ajouté avec succès",
    "memberRemoved": "Membre retiré avec succès",
    "subscriptionCanceled": "Abonnement annulé en fin de période",
    "subscriptionReactivated": "Abonnement réactivé"
  },
  "errors": {
    "loadInstitutionFailed": "Échec du chargement de l'institution",
    "loadInstitutionsFailed": "Échec du chargement des institutions",
    "updateInstitutionFailed": "Échec de la mise à jour de l'institution",
    "offerSeatFailed": "Échec de l'offre du siège",
    "addMemberFailed": "Échec de l'ajout du praticien",
    "removeMemberFailed": "Échec du retrait du membre",
    "cancelSubscriptionFailed": "Échec de l'annulation de l'abonnement",
    "reactivateSubscriptionFailed": "Échec de la réactivation de l'abonnement",
    "activateTrialFailed": "Échec de l'activation de l'essai",
    "updateTrialFailed": "Échec de la mise à jour de l'essai",
    "endTrialFailed": "Échec de la terminaison de l'essai"
  }
}
